import React from 'react';
import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';
import './index.css';

const galerias = {
  numeros: [
    '/galerias/galeria-1/img-01.jpg',
    '/galerias/galeria-1/img-02.jpg',
    '/galerias/galeria-1/img-03.jpg',
    '/galerias/galeria-1/img-04.jpg',
    '/galerias/galeria-1/img-05.jpg',
    '/galerias/galeria-1/img-06.jpg',
    '/galerias/galeria-1/img-07.jpg',
    '/galerias/galeria-1/img-08.jpg',
    '/galerias/galeria-1/img-09.jpg',
    '/galerias/galeria-1/img-10.jpg',
    '/galerias/galeria-1/img-11.jpg',
    '/galerias/galeria-1/img-12.jpg',
    '/galerias/galeria-1/img-13.jpg',
    '/galerias/galeria-1/img-14.jpg',
    '/galerias/galeria-1/img-15.jpg',
    '/galerias/galeria-1/img-16.jpg',
    '/galerias/galeria-1/img-17.jpg',
    '/galerias/galeria-1/img-18.jpg',
    '/galerias/galeria-1/img-19.jpg',
  ],
  incluir: [
    '/galerias/galeria-2/img-01.jpg',
    '/galerias/galeria-2/img-02.jpg',
    '/galerias/galeria-2/img-03.jpg',
    '/galerias/galeria-2/img-04.jpg',
    '/galerias/galeria-2/img-05.jpg'
  ],
  movimiento: [
    '/galerias/galeria-3/img-01.jpg',
    '/galerias/galeria-3/img-02.jpg',
    '/galerias/galeria-3/img-03.jpg',
    '/galerias/galeria-3/img-04.jpg',
    '/galerias/galeria-3/img-05.jpg',
    '/galerias/galeria-3/img-06.jpg',
    '/galerias/galeria-3/img-07.jpg',
    '/galerias/galeria-3/img-08.jpg',
    '/galerias/galeria-3/img-09.jpg',
    '/galerias/galeria-3/img-10.jpg'
  ]
}

const settings = {
  // loop: true,
  // autoplayHoverPause: true,
  lazyload: true,
  nav: false,
  mouseDrag: true,
  items: 1,
  gutter: 25,
  controls: false,
  autoplayButton: false,
  speed: 300,
  autoplay: true,
  edgePadding: 15,
  autoplayTimeout: 2500,
  autoHeight: true,
  responsive: {
    420: {
      items: 2
    },
    768: {
      items: 3
    }
  }
};

function ImageSlider({galeria}) {
  return (
    <div className="imageslider tns-gallery">
      <TinySlider settings={settings}>
        {galerias[galeria].map((el, index) => (
          <div key={index}>
            <span>
              <img
                className={`tns-lazy-img`}
                data-src={el}
                alt=""
              />
            </span>
          </div>
        ))}
      </TinySlider>
    </div>
  );
}

export default ImageSlider;
